import { render, staticRenderFns } from "./AddPartRecordContainer.vue?vue&type=template&id=0d6cbe61"
import script from "./AddPartRecordContainer.vue?vue&type=script&lang=js"
export * from "./AddPartRecordContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports